import React from "react";
import { Box, Paper, Stack, Typography, Button, Tooltip, Fade } from "@mui/material";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { theme } from "../../../../Theme";

export function SelectedSkusActionBar({
  selectedSkus,
  onClear,
  onSendToSimulator,
  onSendToOptimizer,
}) {
  const count = selectedSkus.size;
  const show = count > 0;

  return (
    <Fade in={show} timeout={280} unmountOnExit>
      <Box
        sx={{
          position: "fixed",
          bottom: 28,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1300,
          pointerEvents: show ? "auto" : "none",
        }}
      >
        <Paper
          elevation={8}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 1, sm: 2 },
            px: { xs: 1.75, sm: 2.5 },
            py: 1.25,
            borderRadius: 3,
            bgcolor: "#1A2236",
            color: "#fff",
            boxShadow:
              "0 8px 32px rgba(15,23,42,0.32), 0 2px 8px rgba(15,23,42,0.18)",
            flexWrap: { xs: "wrap", sm: "nowrap" },
            minWidth: { xs: "calc(100vw - 48px)", sm: "auto" },
            maxWidth: "calc(100vw - 48px)",
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ flexShrink: 0 }}
          >
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: 1.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: `${theme.palette.primary.main}30`,
              }}
            >
              <CheckBoxOutlinedIcon
                sx={{ fontSize: 18, color: theme.palette.primary.light }}
              />
            </Box>
            <Typography
              variant="body2"
              fontWeight={700}
              sx={{ color: "#E2E8F0", whiteSpace: "nowrap" }}
            >
              {count} SKU{count !== 1 ? "s" : ""} selected
            </Typography>
          </Stack>

          <Box sx={{ flex: 1, minWidth: 8 }} />

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            flexWrap="wrap"
            useFlexGap
          >
            <Button
              size="small"
              variant="contained"
              startIcon={<PlayArrowOutlinedIcon sx={{ fontSize: 17 }} />}
              onClick={onSendToSimulator}
              sx={{
                bgcolor: theme.palette.primary.main,
                color: "#fff",
                fontWeight: 700,
                fontSize: 12.5,
                textTransform: "none",
                borderRadius: 2,
                px: 1.75,
                py: 0.75,
                whiteSpace: "nowrap",
                boxShadow: "0 2px 8px rgba(25,118,210,0.35)",
                "&:hover": {
                  bgcolor: theme.palette.primary.dark,
                  boxShadow: "0 4px 14px rgba(25,118,210,0.45)",
                },
              }}
            >
              Simulate
            </Button>

            <Button
              size="small"
              variant="contained"
              startIcon={<AutoFixHighIcon sx={{ fontSize: 17 }} />}
              onClick={onSendToOptimizer}
              sx={{
                bgcolor: "#7C3AED",
                color: "#fff",
                fontWeight: 700,
                fontSize: 12.5,
                textTransform: "none",
                borderRadius: 2,
                px: 1.75,
                py: 0.75,
                whiteSpace: "nowrap",
                boxShadow: "0 2px 8px rgba(124,58,237,0.35)",
                "&:hover": {
                  bgcolor: "#6D28D9",
                  boxShadow: "0 4px 14px rgba(124,58,237,0.45)",
                },
              }}
            >
              Optimize
            </Button>

            <Tooltip title="Clear selection" arrow>
              <Box
                component="button"
                onClick={onClear}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 30,
                  height: 30,
                  borderRadius: 1.5,
                  border: "none",
                  cursor: "pointer",
                  bgcolor: "rgba(255,255,255,0.08)",
                  color: "#94A3B8",
                  transition: "background 0.15s, color 0.15s",
                  "&:hover": {
                    bgcolor: "rgba(255,255,255,0.16)",
                    color: "#E2E8F0",
                  },
                }}
              >
                <CloseIcon sx={{ fontSize: 16 }} />
              </Box>
            </Tooltip>
          </Stack>
        </Paper>
      </Box>
    </Fade>
  );
}
